import React, { Component } from "react";
import DatePicker from "react-datepicker";
import Moment from "moment";

import "react-datepicker/dist/react-datepicker.css";

export interface DateProps {
    field?: any;
    form?: any;
    inputtype?: string;
    placeholder?: string;
    givenid?: string;
    showtime?: boolean;
    minutesinterval?: number;
    isConfig?: boolean;
}

export default class BaseDate extends Component<DateProps, {}> {
    //baseValue;

    handleOnChange = date => {
        const { field } = this.props;
        let { touched } = this.props.form;
        touched[field.name] = true;
        this.props.form.setTouched(touched);
        if (date !== null) {
            this.props.form.setFieldValue(
                this.props.field.name,
                Moment(date).format("YYYY-MM-DD HH:mm")
            );
        } else {
            this.props.form.setFieldValue(this.props.field.name, null);
        }
    };

    componentDidMount() {
        const fieldName = this.props.field.name;
        //this.baseValue = this.props.field.value;
        let elem = document.querySelector(`.${fieldName}.read-only`);
        if (elem) {
            elem.setAttribute("readonly", "readonly");
        }
    }

    render() {
        const fieldName = this.props.field.name;
        const errors =
            this.props.form.errors[fieldName] != "Field is required."  || this.props.isConfig
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                  this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                <span className="input-error-message">{errors}</span>
            </div>
        );

        let selected = undefined;
        if (
            this.props.field.value !== "" &&
            this.props.field.value !== undefined &&
            this.props.field.value !== null
        ) {
            selected = new Date(this.props.field.value.replace(/-/g, "/"));
            if (!(selected instanceof Date) || isNaN(selected.getDay())) {
                selected = undefined;
            }
        }

        return (
            <div id={this.props.givenid + "Input"}>
                <div
                    className={
                        "input-group " + (errors ? "input-group-error" : "")
                    }
                >
                    <DatePicker
                        selected={selected}
                        placeholderText={this.props.placeholder}
                        onChange={date => this.handleOnChange(date)}
                        timeInputLabel="Time:"
                        showTimeInput={this.props.showtime}
                        timeIntervals={this.props.minutesinterval}
                        timeFormat="HH:mm"
                        isClearable
                        dateFormat="yyyy-MM-dd HH:mm"
                        className={`${fieldName} read-only input date-input`}
                    />
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
